<template>
    <div class="chart-one">
      <div class="box">
        <h1>基础设施安全漏洞影响力综合排名</h1>
        <!-- 背景光圈  -->
        <div class="background">
          <img src="../../assets/PlatformOverview/chartOneBackground.png" alt="">
        </div>
        <!-- 中间最大的圆  -->
        <div class="big">
          <img src="@assets/PlatformOverview/big1.png" alt="">
          <div class="bigText">
            <h2>{{data[0].vul_name || ""}}</h2>
            <h2>{{data[0].vul_score || ""}}</h2>
          </div>

        </div>

        <!-- 左上  -->
        <div class="leftTop">
          <img src="@assets/PlatformOverview/leftTop.png" alt="">
          <div class="leftTopText">
            <h2>{{data[1].vul_name || ""}}</h2>
            <h2>{{data[1].vul_score || ""}}</h2>
          </div>
          <div class="leftTopBall">
            <img src="@assets/PlatformOverview/ball-3.png" alt="">
          </div>
        </div>

        <!-- 左下  -->
        <div class="leftBottom">
          <img src="@assets/PlatformOverview/leftBottom.png" alt="">
          <div class="leftBottomText">
            <h2>{{data[2].vul_name || ""}}</h2>
            <h2>{{data[2].vul_score || ""}}</h2>
          </div>
          <div class="leftBottomBall">
            <img src="@assets/PlatformOverview/ball-4.png" alt="">
          </div>
        </div>

        <!-- 右上  -->
        <div class="rightTop">
          <img src="@assets/PlatformOverview/rightTop.png" alt="">
          <div class="rightTopText">
            <h2>{{data[3].vul_name || ""}}</h2>
            <h2>{{data[3].vul_score || ""}}</h2>
          </div>
          <div class="rightTopBall">
            <img src="@assets/PlatformOverview/ball-2.png" alt="">
          </div>
        </div>

        <!-- 右下  -->
        <div class="rightBottom">
          <img src="@assets/PlatformOverview/rightBottom.png" alt="">
          <div class="rightBottomText">
            <h2>{{data[4].vul_name || ""}}</h2>
            <h2>{{data[4].vul_score || ""}}</h2>
          </div>
          <div class="rightBottomBall">
            <img src="@assets/PlatformOverview/ball-1.png" alt="">
          </div>
        </div>

      </div>
    </div>
</template>
<style scoped lang="less">
.chart-one {
    background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
    width: 430px;
    height: 247px;
    border-radius:10px ;
    color: rgba(255, 255, 255, 1);
    font-family: 'YouSheBiaoTiHei';

}
.box {
  position: relative;
}
h1{
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 31px;
  position: absolute;
  left: 36px;
  top: 15px;
}
img{
  width: 100%;
}
.background{
  width: 232px;
  height: 198px;
  position: absolute;
  left: 84px;
  top:41px;
  z-index: 999;
}
.big{
  width: 200px;
  height: 200px;
  position: absolute;
  left: 125px;
  top:45px;
}
.bigText{
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%,-50%);
}
h2{
  font-size: 26px;
  width: 112px;
  height: 34px;
  line-height: 34px;
}
.leftTop{
  width: 91px;
  position: absolute;
  left:31px;
  top:53px;
  .leftTopText{
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%,-50%);
    h2{
      height: 18px;
      font-size:12px;
    }
  }
}
.leftTopBall{
  width: 76px;
  position: absolute;
  left:7px;
  top:28px;
}
.leftBottom{
  width: 51px;
  position: absolute;
  left:84px;
  top:166px;
  .leftBottomText{
    position: absolute;
    left: 50%;
    top: 35%;
    transform: translate(-50%,-50%);
    h2{
      height: 12px;
      font-size:10px;
    }
  }
}
.leftBottomBall{
  width:58px;
  position: absolute;
  left:-5px;
  top:8px;
}
.rightTop{
  width: 51px;
  position: absolute;
  left:287px;
  top:50px;
  .rightTopText{
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%,-50%);
    h2{
      height: 12px;
      font-size:8px;
    }
  }
}
.rightTopBall{
  width: 42px;
  position: absolute;
  left:4px;
  top:16px;
}
.rightBottom{
  width: 105px;
  position: absolute;
  left:309px;
  top:128px;
  .rightBottomText{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    h2{
      height: 24px;
      font-size:18px;
    }
  }
}
.rightBottomBall{
  width:120px;
  position: absolute;
  left:-8px;
  top:-4px;
}
</style>
<script>
import {getBasicSecurity} from "@/service/dashboard";
export default {
  data(){
    return {
      data: [{"vul_name":"海啸之王","vul_score":69},{"vul_name":"新型缓存污染","vul_score":71},{"vul_name":"海啸之王","vul_score":69},{"vul_name":"海啸之王","vul_score":71},{"vul_name":"海啸之王","vul_score":71}]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getBasicSecurity().then(res => {
        this.data = res;
      });
    }
  }
};
</script>
